
import { Options, Vue } from "vue-class-component";
import {
  readAccountList,
  readPipelineList,
  readPipelinePkgList,
  readSimpleScriptList,
  readTaskList,
  readTaskStats,
  readTaskPerformanceVersions,
} from "@/store/task/getters";
import { store } from "@/store";
import { ElMessage } from "element-plus";
import axios from 'axios'
import {
  dispatchGetTasks,
  dispatchDeleteTask,
  dispatchCreateTask,
  dispatchCopyData,
  dispatchUpdateTask,
  dispatchRunTask,
  dispatchGetSimpleScripts,
  dispatchGetPipelines,
  dispatchGetAccounts,
  dispatchGetTaskStats,
  dispatchGetPipelinePkgs,
  dispatchGetPerformanceVersions,
  dispatchGetPerformanceVersionsCreate,
} from "@/store/task/actions";
import { IReportSettings, ITaskContent } from "@/interfaces";
import SideMenu from "@/components/WorkBench/SideMenu.vue";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { readDeviceSpecs } from "@/store/device/getters";

import {
  compare,
  dateConversion,
  getLocalProject,
  getLocalTaskForm,
  regChineseObJ,
  removeLocalTaskForm,
  saveLocalTaskForm,
  special_projects,
  typeConversion,
  unique_json,
} from "@/utils";
import { commitRunTask } from "@/store/task/mutations";
import {
  readAdminProjects,
  readMyProjects,
  readProjectDetail,
  readProjectScenes,
  readProjectUsers,
} from "@/store/project/getters";
import {
  dispatchGetProjectDetail,
  dispatchGetProjects,
  dispatchGetProjectScenes,
  dispatchGetProjectUsers,
} from "@/store/project/actions";
// import God from "@/assets/js/god.js";
import {
  dispatchGetAllIndexes,
  dispatchGetHeroSkin,
  dispatchGetMobaProjects,
} from "@/store/main/actions";
import {
  readAllIndexes,
  readHeroSkin,
  readMobaProjects,
  readUserProfile,
} from "@/store/main/getters";

@Options({
  components: {
    SideMenu,
  },
})
export default class Task extends Vue {
  data() {
    // 新建任务配置表单会缓存在本地, 方便用户切换页面仍可访问上次正在新建配置的表单
    if (getLocalTaskForm()) {
      return {
        ruleForm: JSON.parse(getLocalTaskForm() as string),
      };
    } else {
      return {
        // 任务配置表单(编辑和新建共用此表单)
        ruleForm: {
          task_name: "",
          sub_project: this.project,
          global_settings_trigger_type: 0,
          global_settings_trigger_value: "",
          global_settings_trigger_ios_value: "",
          global_settings_trigger_value_interval: "week",
          global_settings_trigger_value_day: "1",
          global_settings_trigger_value_time: "00:01",
          global_settings_downloader_type: 0,
          global_settings_downloader_time: [],
          global_settings_downloader_pipeline: "",
          global_settings_downloader_pipeline2: "",
          global_settings_downloader_build_id: "",
          global_settings_downloader_build_id2: "",
          global_settings_login_type: -1,
          global_settings_login_value: "",
          global_settings_conditions_type: -1,
          global_settings_conditions_value: "",
          global_settings_collector_type: -1,
          global_settings_collector_value: "",
          global_settings_task_group: [],
          device_enter_scene_type: 0,
          device_enter_scene_value: "",
          automatic_retry: false,
          is_cancel: true,
          generate_report: true,
          ignore_device_offline: false,
          pipeline_auto_one: false,
          sampleProfiler: false,
          GpuCounter: false,
          perfetto: false,
          pkg_name_by_manual: "",
          no_push_resources: false,
          no_install: false,
          screenshot: false,
          except_check: false,

          upload_svn: false,
          svn_dir: "",
          report_type: 0,
          subtype: "",
          custom: "",
        },
      };
    }
  }

  /* 批量导入 */
  public async onMultiImport(ev) {
    const form = new FormData()
    form.append('project', this.localProject + '')
    //form.append('project', '7')
    form.append('file', ev.raw)

    let {data} = await (axios as any).post('task/task_scene_import/', form)

    for (let item of data) {
      item.scene_id = item.scene_id + ''
      item.device_group = Object.keys(item.device_group).map(id => {
        const device = item.device_group[id]
        device.script = device.script + ''
        device.custom_json = JSON.stringify(device.custom_json)

        return {
          id,
          ...device,
        }
      })
    }
   
    (this as any).ruleForm?.global_settings_task_group?.push(...data)
  }
  /**/

  public automaticRetry = false; //任务失败自动重试
  public currentPage1 = 1;
  public record = 16; //记录条数
  public ruleform_page = 1;
  public ruleform_size = 5;
  public localProject = Number(getLocalProject());
  // 获得统计数据
  public get getVisitStatistics() {
    return readTaskList(store);
  }
  public timeGet(item) {
    console.log(item);
    if (item != null && item.length != 0) {
      let start = dateConversion(item[0]).match(/\d{2}:\d{2}/)[0];
      let end = dateConversion(item[1]).match(/\d{2}:\d{2}/)[0];
      return [start, end];
    } else {
      return ["", ""];
    }
  }
  public custom_json = "";
  public task_group_index = 0;
  public device_group_index = 0;
  public open(index: number, device_index: number, ruleForm: any) {
    this.task_group_index = index;
    this.device_group_index = device_index;
    this.custom_json =
      ruleForm.global_settings_task_group[this.task_group_index].device_group[
        this.device_group_index
      ]?.custom_json || "{}";
    this.dialogFormVisible1 = true;
  }
  public get versionsList() {
    return readTaskPerformanceVersions(store);
  }
  public open1() {
    if (!(this as any).ruleForm.custom) {
      (this as any).ruleForm.custom = '{}'
    }
    
    this.dialogFormVisible2 = true;
  }


  closeDialogVersion() {
    this.dialogAddVersionVisible = false
    this.taskVersion = ''
  }

  async submitVersion() {
    if (!this.taskVersion.trim()) {
      return ElMessage.warning('请输入版本')
    }

    let row: any = this.versionData;
    const data = await dispatchRunTask(store, {
      task: row.task_id,
      project: row.project,
      control_type: this.control_type_version,
      version: this.taskVersion,
    });

    if (data.success) {
      commitRunTask(store, {
        project: row.project,
        page: this.currentPage1,
        task_name: this.search1,
        size: this.record,
      });

      // commitRunTask(store, row.project);

      if (this.control_type_version === 0) {
        //  this.dialogAddFormVisible=true
        //  dispatchGetPerformanceVersions(store,{
        //    project:this.localProject
        //  })
        this.dialogAddVersionVisible = false;
        ElMessage({
          message: "任务启动成功，可通过当前状态查看任务详情",
          type: "success",
        });
        // const isConfirm: boolean = confirm(
        //   "任务启动成功, 是否跳转到任务执行界面?"
        // );
        // if (isConfirm) {
        //   const { href } = this.$router.resolve({
        //     path: "/taskDetails",
        //     query: {
        //       id: value.task_record_id,
        //       // id: value.task_record_id,
        //     },
        //   });
        //   window.open(href, "_blank");
        //   return Promise.resolve(false); // 不刷新表格
        // }
      }
    }
  }

  public submitAddForm() {
    let row: any = this.versionData;
    const response_data = dispatchRunTask(store, {
      task: row.task_id,
      project: row.project,
      control_type: this.control_type_version,
      version: this.filterVersions
        ? this.versionsList.filter((v) => v.id == this.filterVersions)[0]
            .version
        : "",
    });
    response_data.then((value) => {
      if (value.success) {
        commitRunTask(store, {
          project: row.project,
          page: this.currentPage1,
          task_name: this.search1,
          size: this.record,
        });

        // commitRunTask(store, row.project);

        if (this.control_type_version === 0) {
          //  this.dialogAddFormVisible=true
          //  dispatchGetPerformanceVersions(store,{
          //    project:this.localProject
          //  })
          this.dialogAddFormVisible = false;
          ElMessage({
            message: "任务启动成功，可通过当前状态查看任务详情",
            type: "success",
          });
          // const isConfirm: boolean = confirm(
          //   "任务启动成功, 是否跳转到任务执行界面?"
          // );
          // if (isConfirm) {
          //   const { href } = this.$router.resolve({
          //     path: "/taskDetails",
          //     query: {
          //       id: value.task_record_id,
          //       // id: value.task_record_id,
          //     },
          //   });
          //   window.open(href, "_blank");
          //   return Promise.resolve(false); // 不刷新表格
          // }
        }
      }
    });
  }
  public isValidJsonOrEmpty(custom_json) {
    if (custom_json === "") {
      return true; // 空字符串时返回 true
    }

    try {
      JSON.parse(custom_json);
      console.log(JSON.parse(custom_json));
      return true; // 解析成功说明是有效的 JSON 字符串
    } catch (e) {
      return false; // 解析失败说明不是有效的 JSON 字符串
    }
  }

  public closeBtn(ruleForm: any) {
    if (this.isValidJsonOrEmpty(this.custom_json)) {
      ruleForm.global_settings_task_group[this.task_group_index].device_group[
        this.device_group_index
      ].custom_json = this.custom_json;
      this.dialogFormVisible1 = false;
    } else {
      ElMessage.error("json格式错误");
    }
  }
  //查询、分页
  public async onSearch(operation: any) {
    this.loading = true;
    await dispatchGetTasks(store, {
      project: this.localProject,
      page: operation === "Search" ? 1 : this.currentPage1,
      task_name: this.search1,
      size: this.record,
    });
    this.loading = false;
  }

  // 触发器类型
  public trigger_types = { 0: "手动", 1: "自动检测流水线", 2: "定时器" };
  // 登陆器类型
  public login_types = { 0: "手动登陆", 1: "接口登录", 2: "图像识别登录" };
  // 任务状态
  public task_record_status = {
    0: "空闲",
    1: "进行中",
    2: "暂停",
    3: "完成",
    4: "取消",
    5: "异常",
  };
  public async addAddScript() {
    await dispatchGetPerformanceVersionsCreate(store, {
      project: this.localProject,
      version: this.addVersion,
    });
    this.addScript = false;

    await dispatchGetPerformanceVersions(store, {
      project: this.localProject,
    });
    ElMessage({
      message: "创建成功",
      type: "success",
    });
  }
  // 启动条件
  public conditions_types = {
    0: "重启游戏",
    1: "等待时间",
    2: "重启手机",
    3: "温度",
  };
  // 采集器
  public collector_types = { 0: "客户端性能", 1: "功能冒烟", 2: "稳定性采集" };
  public search = "";
  public search1 = "";
  public active_collapases = ["1"];
  public range = (start: number, stop: number, step = 1) =>
    Array(Math.ceil((stop - start) / step))
      .fill(start)
      .map((x, y) => x + y * step);

  get day_options() {
    const days: any[] = [
      { label: "周一", value: "1" },
      { label: "周二", value: "2" },
      { label: "周三", value: "3" },
      { label: "周四", value: "4" },
      { label: "周五", value: "5" },
      { label: "周六", value: "6" },
      { label: "周日", value: "7" },
    ];
    // for (let index = 0; index < this.range(1, 8).length; index++) {
    //   const day = this.range(1, 8)[index];
    //   days.push({
    //     label: day,
    //     value: day,
    //   });
    // }
    return days;
  }

  public close_form = "";
  public formTask = false;
  public time_placeholder = "选择时间";
  public re_chinese = (rule: any, value: any, callback: any) => {
    if (!regChineseObJ.test(value)) {
      callback(
        new Error(
          "任务名称只支持中英文、数字、下划线、英文冒号、英文句号及横线"
        )
      );
    } else {
      callback();
    }
  };
  public rules = {
    task_name: [
      { required: true, message: "请输入任务名称", trigger: "blur" },
      { validator: this.re_chinese, trigger: "blur" },
    ],
  };

  public handleFormConfirm = "创建";
  public handleFormTitle = "创建任务";

  public cache_ruleForm: any = {};
  public project = Number(getLocalProject());
  public is_disabled_downloader_pipeline = false;

  public loading = false;
  public d = "";

  // 报告设置
  public items = ["标签一", "标签二", "标签三"];
  public checked1 = true;
  public form = "";
  public display = { display: "none" };
  public dropDownSelection() {
    this.display = { display: "block" };
  }
  public handleClearAll(type: string) {
    if (type !== "basic" && type !== "advance" && type !== "customize") {
      (this.report_settings.content as any)[type] = [];
    } else {
      (this.report_settings.content.index_type as any)[type] = [];
    }
  }
  public filterVersions = "";
  public handleSelectAll(type: string, all_list: any[]) {
    if (type !== "basic" && type !== "advance" && type !== "customize") {
      if (
        type === "core_scene" ||
        type === "trend_scene" ||
        type === "exclude_scene" ||
        type === "exclude_device"
      ) {
        const item = all_list.map((item) => item.id);
        (this.report_settings.content as any)[type] = item;
      } else {
        (this.report_settings.content as any)[type] = all_list;
      }
    } else {
      let difference = [];
      if (type === "basic") {
        let advance_customize: string[] = [];
        advance_customize.push(
          ...this.report_settings.content.index_type.customize
        );
        advance_customize.push(
          ...this.report_settings.content.index_type.advance
        );
        // （a-b 差集：属于a但不属于b的集合）a-b=[1,3],b-a=[4,5] eg: a = [1, 2, 3]，b = [2, 4, 5]
        difference = all_list.filter((v) => !advance_customize.includes(v));
      } else if (type === "advance") {
        let basic_customize: string[] = [];
        basic_customize.push(
          ...this.report_settings.content.index_type.customize
        );
        basic_customize.push(...this.report_settings.content.index_type.basic);
        difference = all_list.filter((v) => !basic_customize.includes(v));
      } else {
        let basic_advance: string[] = [];
        basic_advance.push(...this.report_settings.content.index_type.advance);
        basic_advance.push(...this.report_settings.content.index_type.basic);
        difference = all_list.filter((v) => !basic_advance.includes(v));
      }

      (this.report_settings.content.index_type as any)[type] = difference;
    }
  }

  public report_settings: IReportSettings = {
    content: {
      core_index: [], //核心指数
      trend_index: [], //趋势指数
      exclude_scene: [], //排除场景
      exclude_device: [], //排除设备
      core_scene: [], //核心性能表展示的场景
      trend_scene: [], // 趋势图展示的场景
      show_index: [], //显示指标
      index_type: {
        //指标类型
        basic: [], //基础指标
        advance: [], //深度指标
        customize: [], //定制指标
      },
      trend_number: 10, // 趋势图的版本数
      trend_integrity: false, //趋势图完整性，是否允许有缺失数据
      is_have_old: true, //数据详情模块，是否展示
    },

    notify: {
      //通知
      email: {
        enable: false,
        receiver_str: "", // 接收人列表转字符串，用 ";" 拼接
        receiver: [], //接收
      },
      wecom: {
        enable: false,
        receiver_str: "",
        receiver: [],
      },
      wecom_robot: {
        enable: false,
        receiver: [],
        receiver_str: "",
      },
    },
  };
  public value1 = [];
  public value2 = [];
  public task_form_loading = false;
  public handleClose(tag: any, type: string) {
    if (type !== "basic" && type !== "advance" && type !== "customize") {
      (this.report_settings.content as any)?.[type].splice(
        (this.report_settings.content as any)?.[type].indexOf(tag),
        1
      );
    } else {
      (this.report_settings.content.index_type as any)?.[type].splice(
        (this.report_settings.content.index_type as any)?.[type].indexOf(tag),
        1
      );
    }
  }
  public dialogAddFormVisible = false;
  public DeviceChecked: any[] = []; //多选
  public deviceChecked = true;
  // 全选
  public getDeviceChecked(device: any, index: any) {
    device[index].device_group.map((item: any) => {
      item.enable = this.DeviceChecked[index] === true ? true : false;
    });
  }
  public otherDeviceChecked(device: any, index: any) {
    let enableArr: any[] = [];
    device[index].device_group.map((items: any) => {
      enableArr.push(items.enable);
    });
    this.DeviceChecked[index] = enableArr.indexOf(false) != -1 ? false : true;
  }
  public getDeviceChecked2(device: any, index: any) {
    device[index].device_group.map((item: any) => {
      item.enable = this.DeviceChecked[index] = true;
    });
  }

  public dialogVisibleRunmax = false;
  public async mounted() {
    this.loading = true;

    // dispatchGetProjects(store, {project: this.project})
    dispatchGetMobaProjects(store, this.project);
    dispatchGetProjectUsers(store, this.project);
    dispatchGetDeviceSpecs(store, { project: this.project });
    dispatchGetProjectScenes(store, { project: this.project });
    dispatchGetAccounts(store, { project: this.project });
    dispatchGetPipelines(store, { project: this.project });
    dispatchGetSimpleScripts(store, { project: Number(this.project) });
    await dispatchGetTaskStats(store, { project: Number(this.project) });
    await dispatchGetTasks(store, {
      project: this.project,
      page: 1,
      task_name: this.search1,
      size: this.record,
    });
    if (this.projectIsKing) {
      await dispatchGetHeroSkin(store, this.project);
    }

    this.loading = false;
  }

  // 判断当前项目
  // public get get_is_name() {
  //   let get_is_name = readAdminProjects(store).filter(
  //     (item: any) => item.id == this.localProject
  //   )[0]?.project_name;
  //   if (get_is_name === "QQ飞车") {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  public get_projects() {
    return readAdminProjects(store);
  }
  public dialogFormVisible1 = false;
  public dialogFormVisible2 = false;
  public copyForm = {
    count: "",
    task_id: "",
  };
  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  public get is_in_moba_project() {
    const moba = readMobaProjects(store);
    return moba;
  }

  public get project_users() {
    return readProjectUsers(store);
  }

  // 读取可配置指标
  public get get_all_indexes() {
    return readAllIndexes(store);
  }
  public async UploadRunmax() {
    let commitCopy = {
      task_id: Number(this.copyForm.task_id),
      count: Number(this.copyForm.count),
    };
    await dispatchCopyData(store, commitCopy);
    this.dialogVisibleRunmax = false;
    await dispatchGetTasks(store, {
      project: this.localProject,
      page: this.currentPage1,
      task_name: this.search1,
      size: this.record,
    });
    alert("调用成功");
  }

  // 详细指标选择框
  public get_detailed_indexes(type: string, index: string) {
    const basic: any[] = this.report_settings.content.index_type.basic;
    const advance: any[] = this.report_settings.content.index_type.advance;
    const customize: any[] = this.report_settings.content.index_type.customize;
    const all_inedx = readAllIndexes(store);
    // const indexes = all_inedx.filter(
    //   (item) =>
    //     !basic.includes(item) &&
    //     !advance.includes(item) &&
    //     !customize.includes(item)
    // );

    if (type === "basic") {
      if (advance.includes(index) || customize.includes(index)) {
        return true;
      }
    }
    if (type === "advance") {
      if (basic.includes(index) || customize.includes(index)) {
        return true;
      }
    }
    if (type === "customize") {
      if (advance.includes(index) || basic.includes(index)) {
        return true;
      }
    }
    return false;
  }

  public get_scene_chinese(scene_id: number) {
    // for (var i=0;i<this.report_settings.content.exclude_scene.length;i++)
    //   {
    const scene_chinese = this.getProjectScenes.find(
      (scene: any) => scene.id === scene_id
    )?.chinese;
    //     exclude_scene_chinese.push(scene_chinese)
    //   }
    return scene_chinese;
  }

  public get_device_model(device_id: number) {
    const device = this.getDeviceSpecs.find(
      (device) => device.id === device_id
    );
    return device.level + "档机-" + device.model;
  }

  // 获取任务配置表单中的场景列表
  public get_form_scene(task_group: any) {
    let form_scene = [];
    for (var i = 0; i < task_group.length; i++) {
      let scene_chinese = this.getProjectScenes.find(
        (scene: any) => scene.id === task_group[i].scene_id
      )?.chinese;
      form_scene.push({
        id: task_group[i].scene_id,
        chinese: scene_chinese,
      });
    }
    return unique_json(form_scene, "id");
  }

  public send_notify(task_name: string) {
    (this as any).$notify.error({
      title: "警告",
      message: task_name + "任务配置错误，请联系管理员或重新配置任务",
    });
  }

  public get projectIsInvitee() {
    const isInvitee =
      readMyProjects(store).filter(
        (item: any) => item.project.id === Number(this.project)
      )[0]?.project.b_invite || false;
    return isInvitee;
  }
  // 项目是否是王者荣耀
  public get projectIsKing() {
    //9
    if ((this.is_in_moba_project as any).includes(this.project)) {
      return true;
    } else {
      return false;
    }
  }
  // 读取英雄和皮肤
  public get get_hreo() {
    const item = readHeroSkin(store);
    return item.hero_list;
  }
  public get_skin(hero: string) {
    const item = readHeroSkin(store);
    let skin_list = (item.skin_list as any[]).filter(
      (skin) => skin.hero_id === hero
    );
    return skin_list;
  }

  removeTask(item: any, tasks: any) {
    const index = tasks.indexOf(item);
    if (index !== -1) {
      tasks.splice(index, 1);
    }

    if (this.report_settings.content.core_scene) {
      const core_scene_index = (this.report_settings.content
        .core_scene as any[]).indexOf(item.scene_id);
      if (core_scene_index !== -1) {
        this.report_settings.content.core_scene.splice(core_scene_index, 1);
      }
    }

    if (this.report_settings.content.trend_scene) {
      const trend_scene_index = (this.report_settings.content
        .trend_scene as any[]).indexOf(item.scene_id);
      if (trend_scene_index !== -1) {
        this.report_settings.content.trend_scene.splice(trend_scene_index, 1);
      }
    }
  }

  addTask(tasks: any) {
    tasks.push({
      name: "",
      scene_id: readProjectScenes(store)[0]?.id || "",
      cycle_count: 1,
      device_group: [
        {
          id: "",
          account: "",
          custom_json: "",
          script: "",
          invitee: "",
          hero_id: "",
          skin_id: "",
          conditions: {
            type: 1,
            value: 0,
          },
          enable: true,
          // act_prohibit: []
        },
      ],
    });
    tasks.map((item: any, indexs: any) => {
      this.getDeviceChecked2(tasks, indexs);
    });
  }
  copyTask1(item: any, tasks: any) {
    const index = tasks.indexOf(item);
    if (index != -1) {
      // 深拷贝 避免数据更改
      let newTasks = JSON.parse(JSON.stringify(tasks[index]));
      tasks.splice(index + 1, 0, newTasks);
    }
  }
  copyTask(item: any, tasks: any) {
    if (tasks.length !== 0) {
      const cache_tasks: any[] = tasks;
      // tasks.push(...tasks)
      cache_tasks.forEach((item) => {
        const cache_device_group: any[] = item.device_group;
        const new_device_group: any[] = [];
        cache_device_group.forEach((device) => {
          new_device_group.push({
            id: device.id,
            account: device.account,
            custom_json: device.custom_json,
            script: device.script,
            invitee: device.invitee || "",
            hero_id: device.hero_id || "",
            skin_id: device.skin_id || "",
            conditions: {
              type: device.conditions.type,
              value: device.conditions.value,
            },
            enable: device.enable,
            // act_prohibit: []
          });
        });
        tasks.push({
          name: item.name,
          scene_id: item.scene_id,
          cycle_count: item.cycle_count,
          device_group: new_device_group,
        });
      });
    } else {
      tasks.push({
        name: "",
        cycle_count: 1,
        scene_id: readProjectScenes(store)[0]?.id || "",
        device_group: [
          {
            id: "",
            account: "",
            custom_json: "",
            script: "",
            invitee: "",
            hero_id: "",
            skin_id: "",
            conditions: {
              type: 1,
              value: 0,
            },
            enable: true,
            // act_prohibit: []
          },
        ],
      });
    }
    // const devices: any = [];
    // for (let device of item.device_group) {
    //   devices.push({
    //     id: "",
    //     account: device.account,
    //     script: device.script,
    //     invitee: device.invitee || "",
    //     hero_id: device.hero_id || "",
    //     skin_id: device.skin_id || "",
    //     // act_prohibit: device.act_prohibit
    //   });
    // }
    // tasks.push({
    //   name: item.name,
    //   cycle_count: item.cycle_count,
    //   device_group: devices,
    // });
  }
  addDevice(devices: any) {
    devices.push({
      id: "",
      account: "",
      custom_json: "",
      script: "",
      invitee: "",
      hero_id: "",
      skin_id: "",
      conditions: {
        type: 1,
        value: 0,
      },
      enable: true,
      // act_prohibit: []
    });
  }
  removeDevice(device: any, device_group: any) {
    const index = device_group.indexOf(device);
    if (index !== -1) {
      device_group.splice(index, 1);
    }
  }
  copyDevice(device: any, device_group: any) {
    if (device_group.length !== 0) {
      // device_group.push(...cache_device_group)
      // Array.prototype.push.apply(device_group, device_group)   //舍弃这两种方式，是因为它复制的过多，导致更改元素会更改一系列复制元素
      const cache_device_group: any[] = device_group;
      cache_device_group.forEach((item) => {
        device_group.push({
          id: item.id,
          account: item.account,
          custom_json: item.custom_json,
          script: item.script,
          invitee: item.invitee || "",
          hero_id: item.hero_id || "",
          skin_id: item.skin_id || "",
          conditions: {
            type: item.conditions.type,
            value: item.conditions.value,
          },
          enable: item.enable,
          // act_prohibit: device.act_prohibit
        });
      });
    } else {
      device_group.push({
        id: "",
        account: "",
        script: "",
        invitee: "",
        hero_id: "",
        skin_id: "",
        custom_json: "",
        conditions: {
          type: 1,
          value: 0,
        },
        enable: true,
        // act_prohibit: []
      });
    }

    // device_group.push({
    //   id: "",
    //   account: device.account,
    //   script: device.script,
    //   invitee: device.invitee || "",
    //   hero_id: device.hero_id || "",
    //   skin_id: device.skin_id || "",
    //   // act_prohibit: device.act_prohibit
    // });
  }

  submitForm(formName: any, ruleForm: any) {
    this.loading = true;

    (this.$refs[formName] as Vue & { validate: any }).validate((valid: any) => {
      if (valid) {
        if (ruleForm.global_settings_trigger_type === 2) {
          ruleForm.global_settings_trigger_value = {
            interval: ruleForm.global_settings_trigger_value_interval,
            day: String(ruleForm.global_settings_trigger_value_day),
            time: ruleForm.global_settings_trigger_value_time,
          };
        }
        if (ruleForm.global_settings_trigger_ios_value === undefined) {
          ruleForm.global_settings_trigger_ios_value = "";
        }
        if (ruleForm.global_settings_downloader_type === 0) {
          ruleForm.global_settings_downloader_pipeline = "";
          ruleForm.global_settings_downloader_build_id = "";
          ruleForm.global_settings_downloader_pipeline2 = "";
          ruleForm.global_settings_downloader_build_id2 = "";
        } else if (
          ruleForm.global_settings_downloader_type === 1 &&
          ruleForm.global_settings_downloader_pipeline === "" &&
          ruleForm.global_settings_downloader_pipeline2 === ""
        ) {
          alert("请选择流水线");
          return;
        }

        let commitTaskForm: any = {};
        commitTaskForm.task_name = ruleForm.task_name;
        commitTaskForm.task_id = ruleForm.task_id;

        commitTaskForm.task_content = {
          global_settings: {
            trigger: {
              type: ruleForm.global_settings_trigger_type,
              value: ruleForm.global_settings_trigger_value,
              ios_value: ruleForm.global_settings_trigger_ios_value,
            },
            automatic_retry: ruleForm.automatic_retry,
            upload_svn: ruleForm.upload_svn,
            svn_dir: ruleForm.svn_dir,
            is_cancel: ruleForm.is_cancel,
            report_type: ruleForm.report_type,
            subtype: ruleForm.subtype,
            generate_report: ruleForm.generate_report,
            ignore_device_offline: ruleForm.ignore_device_offline,
            pipeline_auto_one: ruleForm.pipeline_auto_one,
            sampleProfiler: ruleForm.sampleProfiler,
            GpuCounter: ruleForm.GpuCounter,
            perfetto: ruleForm.perfetto,
            pkg_name_by_manual: ruleForm.pkg_name_by_manual,

            no_push_resources: ruleForm.no_push_resources,
            no_install: ruleForm.no_install,
            screenshot: ruleForm.screenshot,
            except_check: ruleForm.except_check === true ? false : true,
            downloader: {
              pipeline: ruleForm.global_settings_downloader_pipeline,
              build_id: ruleForm.global_settings_downloader_build_id,
              ios_pipeline: ruleForm.global_settings_downloader_pipeline2,
              ios_build_id: ruleForm.global_settings_downloader_build_id2,
              start: this.timeGet(ruleForm.global_settings_downloader_time)[0],
              end: this.timeGet(ruleForm.global_settings_downloader_time)[1],
            },
            login: {
              type: ruleForm.global_settings_login_type,
              value: ruleForm.global_settings_login_value,
            },
            conditions: {
              type: ruleForm.global_settings_conditions_type,
              value: ruleForm.global_settings_conditions_value,
            },
            collector: {
              type: ruleForm.global_settings_collector_type,
              value: ruleForm.global_settings_collector_value,
            },
            sub_project: ruleForm.sub_project,
          },
          task_group: [],
          report: {
            send_report: true,
            report_template: "",
            send_notify: true,
            notify_type: [],
          },
        };

        if (ruleForm.custom == undefined) {
          commitTaskForm.task_content.custom = {};
        } else {
          commitTaskForm.task_content.custom =
            ruleForm.custom == "" ? {} : JSON.parse(ruleForm.custom);
        }
        for (let task of ruleForm.global_settings_task_group) {
          // if (task.name === "") {
          //   alert("请完善场景名称");
          //   return;
          // }
          // if (task.cycle_count === "") {
          //   alert("请完善循环次数");
          //   return;
          // }
          // if (typeof task.cycle_count !== "number") {
          //   alert("循环次数必须为整数");
          //   return;
          // }
          if (task.scene_id === "") {
            alert("请选择场景");
            return;
          }
          const task_data: any = {
            name: task.name,
            scene_id: task.scene_id,
            conditions: {
              type: ruleForm.global_settings_conditions_type,
              value: ruleForm.global_settings_conditions_value,
            },
            cycle_count: task.cycle_count,
            device_group: {},
            device_order: [],
          };
          for (let device of task.device_group) {
            if (device.id === "" || !device.id) {
              alert("请选择设备或移除设备组");
              return;
            }
            if (device.script === "") {
              alert("请选择脚本");
              return;
            }
            const device_length = (task.device_group as any[]).filter(
              (item) => item.id === device.id
            ).length;
            if (device_length > 1 ? true : false) {
              alert("同一场景设备不可重复");
              return;
            }
            if (typeof device.conditions.value !== "number") {
              alert("等待时长必须为数字");
              return;
            }

            let device_invitee = [];
            if (device.invitee.length !== 0) {
              device_invitee = device.invitee.split(",");
            }
            task_data.device_order.push(device.id);
            task_data.device_group[device.id] = {
              account: device.account,
              custom_json:
                device.custom_json === "" || !device.custom_json
                  ? {}
                  : JSON.parse(device.custom_json),
              enter_scene: {
                type: ruleForm.device_enter_scene_type,
                value: ruleForm.device_enter_scene_value,
              },
              script: device.script,
              invitee: device_invitee,
              hero_id: Number(device.hero_id),
              skin_id: Number(device.skin_id),
              conditions: {
                type: device.conditions?.type || 1,
                value: device.conditions?.value || 0,
              },
              enable: device.enable,
              // act_prohibit: device.act_prohibit
            };
          }
          commitTaskForm.task_content.task_group.push(task_data);
        }

        commitTaskForm.task_content = JSON.stringify(
          commitTaskForm.task_content
        );

        // this.report_settings.notify.email.receiver = (this.report_settings
        //   .notify.email.receiver_str as string).split(";");
        // this.report_settings.notify.wecom.receiver = (this.report_settings
        //   .notify.wecom.receiver_str as string).split(";");

        let receiver_value: any = this.report_settings.notify.email
          .receiver_str;
        let receiver_value2: any = this.report_settings.notify.wecom
          .receiver_str;

        let submit_receiver_value: any = receiver_value
          .split(";")
          .map((item: any) => {
            if (item.indexOf("(") !== -1) {
              return item.substring(0, item.lastIndexOf("("));
            } else {
              return item;
            }
          });

        let submit_receiver_value2: any = receiver_value2
          .split(";")
          .map((item: any) => {
            if (item.indexOf("(") !== -1) {
              return item.substring(0, item.lastIndexOf("("));
            } else {
              return item;
            }
          });
        this.report_settings.notify.email.receiver = submit_receiver_value;
        this.report_settings.notify.wecom.receiver = submit_receiver_value2;

        // let submit_receiver_value: any = receiver_value
        //   .split(";")
        //   .map((item: any) => {
        //     return item.substring(0, item.lastIndexOf("("));
        //   });
        // let submit_receiver_value2: any = receiver_value2
        //   .split(";")
        //   .map((item: any) => {
        //     return item.substring(0, item.lastIndexOf("("));
        //   });

        // let submit_receiver_value3: any = receiver_value.split(";");
        // let submit_receiver_value4: any = receiver_value2.split(";");

        // submit_receiver_value.forEach((item: any) => {
        //   item == ""
        //     ? (this.report_settings.notify.email.receiver = submit_receiver_value3)
        //     : (this.report_settings.notify.email.receiver = submit_receiver_value);
        // });
        // submit_receiver_value2.forEach((item: any) => {
        //   item == ""
        //     ? (this.report_settings.notify.wecom.receiver = submit_receiver_value4)
        //     : (this.report_settings.notify.wecom.receiver = submit_receiver_value2);
        // });

        commitTaskForm.report_settings = JSON.stringify(this.report_settings);
        if (this.handleFormConfirm === "创建") {
          commitTaskForm.project = this.project;
          dispatchCreateTask(store, commitTaskForm);
          dispatchGetTasks(store, {
            project: this.localProject,
            page: this.currentPage1,
            task_name: this.search1,
            size: this.record,
          });
          alert("创建成功！");
        } else {
          commitTaskForm.project = ruleForm.project;
          dispatchUpdateTask(store, {
            id: commitTaskForm.task_id,
            task: commitTaskForm,
          });
          dispatchGetTasks(store, {
            project: this.localProject,
            page: this.currentPage1,
            task_name: this.search1,
            size: this.record,
          });
          alert("配置成功！");
        }

        this.formTask = false;
        this.closed(ruleForm);
        removeLocalTaskForm();
        dispatchGetTasks(store, {
          project: this.localProject,
          page: this.currentPage1,
          task_name: this.search1,
          size: this.record,
        });
        // setTimeout(() => {
        // this.loading = false;
        // }, 1000);
      } else {
        return false;
      }
    });
    this.loading = false;
  }
  closed(ruleForm: any) {
    if (this.close_form === "create") {
      saveLocalTaskForm(JSON.stringify(ruleForm));
    } else {
      ruleForm.task_name = "";
      ruleForm.sub_project = this.project;
      ruleForm.global_settings_trigger_type = 0;
      ruleForm.global_settings_trigger_value = "";
      ruleForm.global_settings_trigger_ios_value = "";
      ruleForm.global_settings_downloader_type = 0;
      ruleForm.global_settings_downloader_pipeline = "";
      ruleForm.global_settings_downloader_build_id = "";
      ruleForm.global_settings_downloader_pipeline2 = "";
      ruleForm.global_settings_downloader_build_id2 = "";
      ruleForm.global_settings_login_type = -1;
      ruleForm.global_settings_login_value = "";
      ruleForm.global_settings_conditions_type = -1;
      ruleForm.global_settings_conditions_value = "";
      ruleForm.global_settings_collector_type = -1;
      ruleForm.global_settings_collector_value = "";
      ruleForm.global_settings_task_group = [];
      ruleForm.device_enter_scene_type = 0;
      ruleForm.device_enter_scene_value = "";
      ruleForm.automatic_retry = false;
      ruleForm.upload_svn = false;
      ruleForm.svn_dir = "";
      ruleForm.screenshot = false;
      ruleForm.except_check = false;
      ruleForm.no_push_resources = false;
      ruleForm.no_install = false;
      ruleForm.is_cancel = true;
      ruleForm.report_type = 0;
      ruleForm.subtype = "";
      ruleForm.custom = "";
      ruleForm.generate_report = false;
      ruleForm.ignore_device_offline = false;
      ruleForm.sampleProfiler = false;
      ruleForm.GpuCounter = false;
      ruleForm.perfetto = false;
      ruleForm.pkg_name_by_manual = "";
      this.handleFormTitle = "创建任务";
      this.handleFormConfirm = "创建";
      removeLocalTaskForm();
    }
    this.active_collapases = ["1"];
  }

  reset(ruleForm: any) {
    ruleForm.task_name = "";
    ruleForm.sub_project = this.project;
    ruleForm.global_settings_trigger_type = 0;
    ruleForm.global_settings_trigger_value = "";
    ruleForm.global_settings_trigger_ios_value = "";
    ruleForm.global_settings_downloader_type = 0;
    ruleForm.global_settings_downloader_pipeline = "";
    ruleForm.global_settings_downloader_build_id = "";
    ruleForm.global_settings_downloader_pipeline2 = "";
    ruleForm.global_settings_downloader_build_id2 = "";
    ruleForm.global_settings_login_type = -1;
    ruleForm.global_settings_login_value = "";
    ruleForm.global_settings_conditions_type = -1;
    ruleForm.global_settings_conditions_value = "";
    ruleForm.global_settings_collector_type = -1;
    ruleForm.global_settings_collector_value = "";
    ruleForm.global_settings_task_group = [];
    ruleForm.device_enter_scene_type = 0;
    ruleForm.device_enter_scene_value = "";
    ruleForm.automatic_retry = false;
    ruleForm.upload_svn = false;
    ruleForm.svn_dir = "";
    ruleForm.is_cancel = true;
    ruleForm.report_type = 0;
    ruleForm.subtype = "";
    ruleForm.custom = "";
    ruleForm.generate_report = true;
    ruleForm.ignore_device_offline = false;

    ruleForm.pipeline_auto_one = false;
    ruleForm.sampleProfiler = false;
    ruleForm.GpuCounter = false;
    ruleForm.perfetto = false;
    ruleForm.pkg_name_by_manual = "";
    ruleForm.screenshot = false;
    ruleForm.except_check = false;
    ruleForm.no_push_resources = false;
    ruleForm.no_install = false;
    removeLocalTaskForm();
    this.copyTask("_", ruleForm.global_settings_task_group);
    this.get_project();
  }

  // 读取项目报告配置
  public get_project() {
    const project = readProjectDetail(store);

    let report_settings_json = JSON.parse(project.report_settings as string);

    // if (report_settings_json.notify.email.receiver.length === 0) {
    //   this.project_users.forEach((item) => {
    //     if (item.is_project_admin === true) {
    //       report_settings_json.notify.email.receiver.push(item.user);
    //     }
    //   });
    // }
    if (report_settings_json.notify.wecom.receiver.length === 0) {
      this.project_users.forEach((item: any) => {
        if (item.is_project_admin === true) {
          report_settings_json.notify.wecom.receiver.push(item.user);
        }
      });
    }
    if (report_settings_json.notify.wecom_robot.receiver.length === 0) {
      this.project_users.forEach((item: any) => {
        if (item.is_project_admin === true) {
          report_settings_json.notify.wecom_robot.receiver.push(item.user);
        }
      });
    }

    // 收件人列表转为拼接为字符串
    report_settings_json.notify.email.receiver_str = report_settings_json.notify.email.receiver.join(
      ";"
    );
    report_settings_json.notify.wecom.receiver_str = report_settings_json.notify.wecom.receiver.join(
      ";"
    );
    report_settings_json.notify.wecom_robot.receiver_str = report_settings_json.notify.wecom_robot.receiver.join(
      ";"
    );
    // 给公共属性赋值
    this.report_settings = report_settings_json;
  }

  setDefaultVal() { //新建任务时，报告设置要有默认值
    this.report_settings.content.core_index = ["avg_fps", "max_pss"]
    this.report_settings.content.trend_index = ["avg_fps", "max_pss", "avg_cpu", "lag_pcnt"]
    this.report_settings.content.show_index = ["max_pss", "avg_fps", "fps_lt_10_pcnt", "fps_lt_18_pcnt", "fps_lt_25_pcnt", "fps_lt_40_pcnt", "avg_cpu", "cpu_lt_60_pcnt", "avg_flow", "dps", "max_vss", "lag_pcnt", "max_mono_total", "max_triangle", "max_dc", "gc_cnt"]
    this.report_settings.content.index_type.basic = ["max_pss", "avg_fps", "fps_lt_10_pcnt", "fps_lt_18_pcnt", "fps_lt_25_pcnt", "fps_lt_40_pcnt", "avg_cpu", "cpu_lt_60_pcnt"]
    this.report_settings.content.index_type.advance = ["max_vss", "lag_pcnt"]
    this.report_settings.content.trend_number = 10
    this.report_settings.content.trend_integrity = true
    this.report_settings.content.is_have_old = true
  }

  public async handleCreateForm(ruleForm: any) {
    this.task_form_loading = true;
    this.formTask = true;
    // this.close_form = "create";

    // dispatchGetPipelinePkgs(store, {
    //   project: this.project,
    //   pipeline_id: null,
    // });
    await dispatchGetAllIndexes(store, { project: this.project });
    this.setDefaultVal()
    // await dispatchGetProjectDetail(store, {
    //   id: this.project,
    //   project: this.project,
    // });
    // this.get_project(); // 读取配置

    // const tasks = ruleForm.global_settings_task_group;
    // const local_tasks = getLocalTaskForm();
    // if (local_tasks) {
    //   ruleForm = JSON.parse(local_tasks);
    //   if (ruleForm.global_settings_trigger_type !== 0) {
    //     this.active_collapases = ["1", "2"];
    //   }
    //   if (
    //     ruleForm.global_settings_downloader_pipeline === "" &&
    //     ruleForm.global_settings_downloader_pipeline2 === ""
    //   ) {
    //     // ruleForm.global_settings_downloader_type = 0;
    //   } else if (ruleForm.global_settings_downloader_build_id !== "") {
    //     this.active_collapases = ["1", "2"];
    //   } else {
    //     this.active_collapases = ["1", "2"];
    //   }
    // }
    //  else {
    //   this.copyTask("_", tasks);
    // }

    // // 新建全选
    // ruleForm.global_settings_task_group.map((item: any, indexs: any) => {
    //   this.getDeviceChecked2(ruleForm.global_settings_task_group, indexs);
    // });
    this.task_form_loading = false;
  }
  public get_is_semi() {
    return special_projects.semi.includes(this.project);
  }
  public show = false;
  public addScript = false;
  public addVersion = "";
  public openAddScript() {
    this.addScript = true;
    this.addVersion = "";
  }
  async handleEdit(ruleForm: any, row: any) {
    this.formTask = true;
    this.task_form_loading = true;
    this.close_form = "edit";
    this.show = true;
    this.num = 0;
    this.ruleform_page = 1;
    this.ruleform_size = 5;
    await dispatchGetAllIndexes(store, { project: this.project });
    await dispatchGetProjectDetail(store, {
      id: this.project,
      project: this.project,
    });
    if (row.is_null_task_content) {
      this.active_collapases = ["1"];
      this.handleFormTitle = "任务配置";
      this.handleFormConfirm = "保存";
      ruleForm.task_id = this.cache_ruleForm.task_id = row.task_id;
      ruleForm.task_name = this.cache_ruleForm.task_name = row.task_name;
      ruleForm.project = this.cache_ruleForm.project = row.project;
      dispatchGetPipelinePkgs(store, {
        project: this.project,
        pipeline_id: null,
      });
      this.get_project(); // 读取配置
      this.copyTask("_", ruleForm.global_settings_task_group);
    } else {
      dispatchGetPipelinePkgs(store, {
        project: this.project,
        pipeline_id: null,
      });
      this.active_collapases = ["1"];
      this.handleFormTitle = "任务配置";
      this.handleFormConfirm = "保存";
      ruleForm.task_id = this.cache_ruleForm.task_id = row.task_id;
      ruleForm.task_name = this.cache_ruleForm.task_name = row.task_name;
      ruleForm.project = this.cache_ruleForm.project = row.project;

      // 报告配置填充值
      let report_settings_json = JSON.parse(row.report_settings as string);

      // if (report_settings_json.notify.email.receiver.length === 0) {
      //   this.project_users.forEach((item) => {
      //     if (item.is_project_admin === true) {
      //       report_settings_json.notify.email.receiver.push(item.user);
      //     }
      //   });
      // }
      if (report_settings_json.notify.wecom.receiver.length === 0) {
        this.project_users.forEach((item: any) => {
          if (item.is_project_admin === true) {
            report_settings_json.notify.wecom.receiver.push(item.user);
          }
        });
      }
      if (report_settings_json.notify.wecom_robot.receiver.length === 0) {
        this.project_users.forEach((item: any) => {
          if (item.is_project_admin === true) {
            report_settings_json.notify.wecom_robot.receiver.push(item.user);
          }
        });
      }
      report_settings_json.content.is_have_old =
        report_settings_json.content.is_have_old === undefined
          ? true
          : report_settings_json.content.is_have_old;
      // 收件人列表转为拼接为字符串
      report_settings_json.notify.email.receiver_str = report_settings_json.notify.email.receiver.join(
        ";"
      );
      report_settings_json.notify.wecom.receiver_str = report_settings_json.notify.wecom.receiver.join(
        ";"
      );
      report_settings_json.notify.wecom_robot.receiver_str = report_settings_json.notify.wecom_robot.receiver.join(
        ";"
      );
      // 给公共属性赋值
      this.report_settings = report_settings_json;

      // ruleForm.task_content = this.cache_ruleForm.task_content = row.task_content

      const task_content_json: ITaskContent =
        JSON.parse(row.task_content) || {};
      ruleForm.sub_project = task_content_json.global_settings?.sub_project
        ? task_content_json.global_settings.sub_project
        : this.project;
      ruleForm.global_settings_trigger_type =
        task_content_json.global_settings.trigger.type;
      if (ruleForm.global_settings_trigger_type !== 0) {
        this.active_collapases = ["1", "2"];
      }
      ruleForm.global_settings_trigger_value =
        task_content_json.global_settings.trigger.value;
      ruleForm.global_settings_trigger_ios_value =
        task_content_json.global_settings.trigger.ios_value;
      ruleForm.global_settings_trigger_value_interval =
        task_content_json.global_settings.trigger.value.interval;
      ruleForm.global_settings_trigger_value_day =
        task_content_json.global_settings.trigger.value.day;
      ruleForm.global_settings_trigger_value_time =
        task_content_json.global_settings.trigger.value.time;
      if (
        task_content_json.global_settings.downloader.pipeline === "" &&
        task_content_json.global_settings.downloader.ios_pipeline === ""
      ) {
        ruleForm.global_settings_downloader_type = 0;
      } else if (
        task_content_json.global_settings.downloader.build_id !== "" ||
        task_content_json.global_settings.downloader.ios_build_id !== ""
      ) {
        ruleForm.global_settings_downloader_type = 2;
        this.active_collapases = ["1", "2"];
      } else {
        ruleForm.global_settings_downloader_type = 1;
        this.active_collapases = ["1", "2"];
      }
      ruleForm.global_settings_downloader_pipeline =
        task_content_json.global_settings.downloader.pipeline;

      ruleForm.global_settings_downloader_build_id =
        task_content_json.global_settings.downloader.build_id;
      ruleForm.global_settings_downloader_pipeline2 =
        task_content_json.global_settings.downloader.ios_pipeline;
      ruleForm.global_settings_downloader_build_id2 =
        task_content_json.global_settings.downloader.ios_build_id;
      ruleForm.global_settings_downloader_time =
        task_content_json.global_settings.downloader.start &&
        task_content_json.global_settings.downloader.end
          ? [
              this.createTime(
                task_content_json.global_settings.downloader.start
              ),
              this.createTime(task_content_json.global_settings.downloader.end),
            ]
          : [];

      ruleForm.automatic_retry =
        task_content_json.global_settings.automatic_retry;

      ruleForm.upload_svn =
        task_content_json.global_settings.upload_svn === undefined
          ? false
          : task_content_json.global_settings.upload_svn;
      ruleForm.svn_dir = task_content_json.global_settings.svn_dir;
      ruleForm.no_push_resources =
        task_content_json.global_settings.no_push_resources;

      //console.log('task_content_json.global_settings.no_install', task_content_json.global_settings.no_install)
      ruleForm.no_install = task_content_json.global_settings.no_install;

      ruleForm.screenshot = task_content_json.global_settings.screenshot;
      ruleForm.except_check =
        task_content_json.global_settings.except_check === false ? true : false;
      ruleForm.is_cancel =
        task_content_json.global_settings?.is_cancel === undefined
          ? true
          : task_content_json.global_settings?.is_cancel;
      ruleForm.report_type =
        task_content_json.global_settings?.report_type == undefined
          ? 0
          : Number(task_content_json.global_settings?.report_type);
      ruleForm.subtype =
        task_content_json.global_settings?.subtype == undefined
          ? ""
          : String(task_content_json.global_settings?.subtype);
      ruleForm.generate_report =
        task_content_json.global_settings?.generate_report === undefined
          ? true
          : task_content_json.global_settings?.generate_report;
      
      ruleForm.ignore_device_offline =
        task_content_json.global_settings?.ignore_device_offline === undefined
          ? false
          : task_content_json.global_settings?.ignore_device_offline;

      ruleForm.pipeline_auto_one =
        task_content_json.global_settings?.pipeline_auto_one === undefined
          ? false
          : task_content_json.global_settings?.pipeline_auto_one;
      ruleForm.sampleProfiler =
        task_content_json.global_settings?.sampleProfiler === undefined
          ? false
          : task_content_json.global_settings?.sampleProfiler;
      ruleForm.GpuCounter =
        task_content_json.global_settings?.GpuCounter === undefined
          ? false
          : task_content_json.global_settings?.GpuCounter;
      ruleForm.perfetto =
        task_content_json.global_settings?.perfetto === undefined
          ? false
          : task_content_json.global_settings?.perfetto;
      ruleForm.pkg_name_by_manual =
        task_content_json.global_settings?.pkg_name_by_manual === undefined
          ? ""
          : task_content_json.global_settings?.pkg_name_by_manual;
      ruleForm.global_settings_login_type =
        task_content_json.global_settings.login.type;
      ruleForm.global_settings_login_value =
        task_content_json.global_settings.login.value;
      ruleForm.global_settings_conditions_type =
        task_content_json.global_settings.conditions.type;
      ruleForm.global_settings_conditions_value =
        task_content_json.global_settings.conditions.value;
      ruleForm.global_settings_collector_type =
        task_content_json.global_settings.collector.type;
      ruleForm.global_settings_collector_value =
        task_content_json.global_settings.collector.value;

      // ruleForm.global_settings_task_group = task_content_json.task_group.slice(
      //   0,
      //   1
      // );
      ruleForm.global_settings_task_group = task_content_json.task_group;
      ruleForm.custom =
        JSON.stringify(task_content_json.custom as any) == "{}"
          ? ""
          : JSON.stringify(task_content_json.custom as any);
      for (let task of task_content_json.task_group) {
        const device_list: any = [];
        if (task.device_order) {
          if (task.device_order.length > 0) {
            (task.device_order as any[]).forEach((device) => {
              const item: any = task.device_group?.[String(device)];
              ruleForm.device_enter_scene_type = item.enter_scene.type;
              ruleForm.device_enter_scene_value = item.enter_scene.value;
              device_list.push({
                id: Number(device),
                account: item.account,
                custom_json: JSON.stringify(item.custom_json),
                enter_scene: {
                  // type: ruleForm.device_enter_scene_type,
                  // value: ruleForm.device_enter_scene_value,
                  // type: item.enter_scene.type,
                  // value: item.enter_scene.value,
                },
                script: item.script,
                hero_id: String(item.hero_id || ""),
                skin_id: String(item.skin_id || ""),
                invitee: item.invitee?.join() || "",
                conditions: {
                  type: item.conditions?.type || 1,
                  value: item.conditions?.value || 0,
                },
                enable: item?.enable === undefined ? true : item?.enable,
                // act_prohibit: item.act_prohibit
              });
            });
          }
        } else {
          for (const [key, value] of Object.entries(task.device_group)) {
            const item: any = value;
            ruleForm.device_enter_scene_type = item.enter_scene.type;
            ruleForm.device_enter_scene_value = item.enter_scene.value;
            device_list.push({
              id: Number(key),
              account: item.account,
              custom_json: JSON.stringify(item.custom_json),
              enter_scene: {
                // type: ruleForm.device_enter_scene_type,
                // value: ruleForm.device_enter_scene_value,
                // type: item.enter_scene.type,
                // value: item.enter_scene.value,
              },
              script: item.script,
              hero_id: String(item.hero_id || ""),
              skin_id: String(item.skin_id || ""),
              invitee: item.invitee?.join() || "",
              conditions: {
                type: item.conditions?.type || 1,
                value: item.conditions?.value || 0,
              },
              enable: item?.enable === undefined ? true : item?.enable,
              // act_prohibit: item.act_prohibit
            });
          }
        }
        task.device_group = device_list;
        // task.scene_id = task.scene_id || readProjectScenes(store)[0]?.id
        // task.cycle_count = task.cycle_count || 1
      }
      this.listData = task_content_json.task_group;

      //         this.UtilHandleBigData(task_content_json.task_group, (data) => {
      //        ruleForm.global_settings_task_group.push(...data)
      //        if( ruleForm.global_settings_task_group.length==task_content_json.task_group.length){
      //          this.show=false
      //        }
      // });
    }

    if (row.report_settings !== readProjectDetail(store).report_settings) {
      this.active_collapases.push("3");
    }
    if (
      ruleForm.automatic_retry === true ||
      ruleForm.is_cancel === false ||
      ruleForm.generate_report === false ||
      ruleForm.screenshot === true ||
      ruleForm.no_push_resources === true ||
      ruleForm.no_install === true
    ) {
      this.active_collapases.push("2");
    }
    // 打开配置时时，判断选中
    ruleForm.global_settings_task_group.map((item: any, indexs: any) => {
      this.otherDeviceChecked(ruleForm.global_settings_task_group, indexs);
    });

    this.task_form_loading = false;
  }
  public versionData = {};
  public control_type_version = 0;
  dialogAddVersionVisible = false
  taskVersion = ''
  handleRun(row: any, control_type: number) {
    console.log(row);
    if (row.is_null_task_content) {
      this.send_notify("");
    } else {
      if (
        this.localProject !== 34 &&
        this.localProject !== 32 &&
        this.localProject !== 57 &&
        this.localProject !== 14 &&
        this.localProject !== 59 &&
        this.localProject !== 71
      ) {
        const response_data = dispatchRunTask(store, {
          task: row.task_id,
          project: row.project,
          control_type: control_type,
        });
        response_data.then((value) => {
          console.log(value);
          if (!value.status) {
            commitRunTask(store, {
              project: row.project,
              page: this.currentPage1,
              task_name: this.search1,
              size: this.record,
            });

            // commitRunTask(store, row.project);

            if (control_type === 0) {
              //  this.dialogAddFormVisible=true
              //  dispatchGetPerformanceVersions(store,{
              //    project:this.localProject
              //  })
              ElMessage({
                message: "任务启动成功，可通过当前状态查看任务详情",
                type: "success",
              });
              // const isConfirm: boolean = confirm(
              //   "任务启动成功, 是否跳转到任务执行界面?"
              // );
              // if (isConfirm) {
              //   const { href } = this.$router.resolve({
              //     path: "/taskDetails",
              //     query: {
              //       id: value.task_record_id,
              //       // id: value.task_record_id,
              //     },
              //   });
              //   window.open(href, "_blank");
              //   return Promise.resolve(false); // 不刷新表格
              // }
            } else {
              alert(value);
            }
          }
        });
      } else {
        this.versionData = row;
        this.control_type_version = control_type;
        if (control_type !== 0) {
          const response_data = dispatchRunTask(store, {
            task: row.task_id,
            project: row.project,
            control_type: control_type,
          });
          response_data.then((value) => {
            console.log(value);
            if (!value.status) {
              commitRunTask(store, {
                project: row.project,
                page: this.currentPage1,
                task_name: this.search1,
                size: this.record,
              });

              // commitRunTask(store, row.project);

              //  this.dialogAddFormVisible=true
              //  dispatchGetPerformanceVersions(store,{
              //    project:this.localProject
              //  })
              // ElMessage({
              //   message: "任务启动成功，可通过当前状态查看任务详情",
              //   type: "success",
              // });
              // const isConfirm: boolean = confirm(
              //   "任务启动成功, 是否跳转到任务执行界面?"
              // );
              // if (isConfirm) {
              //   const { href } = this.$router.resolve({
              //     path: "/taskDetails",
              //     query: {
              //       id: value.task_record_id,
              //       // id: value.task_record_id,
              //     },
              //   });
              //   window.open(href, "_blank");
              //   return Promise.resolve(false); // 不刷新表格
              // }

              alert(value);
            }
          });
        } else if (control_type == 0) {
          if (this.localProject == 59 || this.localProject == 71) {
            this.dialogAddVersionVisible = true
          } else {
            this.dialogAddFormVisible = true;
            dispatchGetPerformanceVersions(store, {
              project: this.localProject,
            })
          }
        }
      }
    }
  }
  public listData = [];
  public stop = false;
  public btnCli = false;
  public num = 0;
  public load() {
    this.stop = true;

    this.num++;
    this;

    if (this.listData.length === 1) {
      this.btnCli = false;
    }
    if (this.num <= this.listData.length - 1) {
      (this as any).ruleForm.global_settings_task_group.push(
        this.listData[this.num]
      );
      // this.btnCli = false;
    }
    if (this.num == this.listData.length - 1) {
      this.btnCli = false;
    }

    this.stop = false;
  }
  public UtilHandleBigData(data, callback, pageSize = 3) {
    let totalCount = data.length; // 共多少条
    let currentPageNumber = 1; // 当前页数
    let totalPageNumer = Math.ceil(totalCount / pageSize); //可分多少页,就是分割为多少个小数组

    let handler = () => {
      let start = (currentPageNumber - 1) * pageSize;
      let end = currentPageNumber * pageSize;
      let currentData = data.slice(start, end); // 当前页的数据
      if (typeof callback === "function") {
        callback(currentData, {
          totalCount,
          totalPageNumer,
          currentPageNumber,
          pageSize,
        });
      }
      // console.log(
      //   `共${totalCount}条,共${totalPageNumer}页,当前第${currentPageNumber}条`
      // );
      if (currentPageNumber < totalPageNumer) {
        window.requestAnimationFrame(handler);
      }
      currentPageNumber++;
    };
    handler();
  }

  public subList = [
    { name: "Default", value: "0" },
    { name: "开profile", value: "1" },
    { name: "关profile", value: "2" },
  ];
  public get subList1() {
    const report_type = (this as any).ruleForm.report_type
    if (report_type == 3 || report_type == 4) {
      return [{ name: "Default", value: "0" }, { name: "灵宝", value: "1" }]
    } else {
      return [{ name: "Default", value: "0" }]
    }
  }
  
  public subList3 = [
    { name: "局内", value: "0" },
    { name: "局外", value: "1" },
  ];
  public selc(item, item1) {
    if (item == 9) {
      item1 = "";
    } else {
      item1 = "";
    }
  }

  public async handleDeleteTask(index: string, row: any) {
    this.loading = true;
    await dispatchDeleteTask(store, { id: row.task_id, project: row.project });
    await dispatchGetTasks(store, {
      project: this.localProject,
      page: this.currentPage1,
      task_name: this.search1,
      size: this.record,
    });
    this.loading = false;
  }

  getTasks(search: any) {
    const task_list: any[] = readTaskList(store).results;
    for (let task of task_list) {
      const task_stat = this.getTaskStats.filter(
        (data) => data?.task === task.task_id
      );
      task.task_record_id = task_stat[0]?.task_record?.id || "-";
      task.status = typeConversion(
        task_stat[0]?.task_record?.status,
        this.task_record_status
      );
      task.start_timestamp = task_stat[0]?.start_timestamp;
      task.start_date =
        dateConversion(task_stat[0]?.task_record?.start_date) || "-";
      task.complete_number = task_stat[0]?.complete_number;
      task.abnormal_number = task_stat[0]?.abnormal_number;

      task.update_date = dateConversion(task.update_date);
      if (!task.task_content) {
        task.task_configuration = [];
        // 这里加了任务内容是否为空的标识(正常情况下不会为空)，涉及到任务的操作时做特别处理
        task.is_null_task_content = true;
      } else {
        task.is_null_task_content = false;
        task.task_content_json = JSON.parse(task.task_content);
        const account_list = readAccountList(store);
        const deviceList: any[] = this.getDeviceSpecs;
        const script_list = readSimpleScriptList(store);

        // 高级设置展开控制
        task.is_expand_settings = false;
        const downloader = task.task_content_json.global_settings.downloader;
        const trigger = task.task_content_json.global_settings.trigger;
        if (downloader.pipeline !== "" || trigger.type !== 0) {
          task.is_expand_settings = true;
        }
        task.downloader_pipeline =
          readPipelineList(store).filter(
            (pipeline) => pipeline.pipeline_id === downloader.pipeline
          )[0]?.pipeline_name || "-";
        if (trigger.type === 1) {
          task.global_settings_trigger_time =
            "自动监控流水线：" +
              readPipelineList(store).filter(
                (pipeline) => pipeline.pipeline_id === trigger.value
              )[0]?.pipeline_name || "-";
        }
        if (trigger.type === 2) {
          if (trigger.value.interval === "week") {
            const week =
              this.day_options.filter(
                (item) => item.value === trigger.value.day
              )[0]?.label || "";
            if (week === "" || !trigger.value.time) {
              task.global_settings_trigger_time = "定时异常";
            } else {
              task.global_settings_trigger_time =
                "每" + week + " " + trigger.value.time + " 触发";
            }
          }
          if (trigger.value.interval === "day") {
            if (!trigger.value.time) {
              task.global_settings_trigger_time = "定时异常";
            } else {
              task.global_settings_trigger_time =
                "每天 " + trigger.value.time + " 触发";
            }
          }
          if (trigger.value.interval === "hour") {
            if (!trigger.value.time) {
              task.global_settings_trigger_time = "定时异常";
            } else {
              const time = trigger.value.time.split(":");
              task.global_settings_trigger_time =
                "每小时 " + time[1] + " 分触发";
            }
          }
        }

        // 任务组列表
        task.task_configuration = [];
        let task_configuration: any[] = [];
        for (let t of task.task_content_json.task_group) {
          let device_list: any[] = [];
          t.scene =
            this.getProjectScenes.filter(
              (item: any) => item.id === t.scene_id
            )[0]?.chinese || "-";

          const device_group: any = Object.entries(t.device_group);

          const rowNum = Object.keys(t.device_group).length;
          const script_count: any = {};
          for (const [key, value] of device_group) {
            const item: any = value;
            const script_id = item?.script;
            if (script_count[script_id]) {
              script_count[script_id] = script_count[script_id] + 1;
            } else {
              script_count[script_id] = 1;
            }
            const data: any = {
              id: key,
              device_name:
                deviceList.filter((data) => data.id.toString() === key)[0]
                  ?.name || "-",
              device_status: deviceList.filter(
                (data) => data.id.toString() === key
              )[0]?.status,
              account:
                account_list.filter(
                  (data) => data.account_id === item.account
                )[0]?.account || "-",
              enter_scene_type: typeConversion(
                item.enter_scene.type,
                this.login_types
              ),
              enter_scene_value: item.enter_scene.value,
              script_id: item?.script,
              script:
                script_list.filter(
                  (data) => item?.script === data?.script_id
                )[0]?.script_name || "-",
              note:
                deviceList.filter((data) => data?.id.toString() === key)[0]
                  ?.remark || "-",
              device_model:
                deviceList.filter((data) => data?.id.toString() === key)[0]
                  ?.model || "-",
              device_level:
                deviceList.filter((data) => data?.id.toString() === key)[0]
                  ?.level || "-",
              // act_prohibit: item.act_prohibit.join(',')
              name: t.name || "",
              scene_id: t.scene_id,
              scene: t.scene || "-",
            };
            device_list.push(data);
            device_list = device_list.sort(compare("script")).reverse();
          }
          // 合并单元格展示
          if (device_list.length !== 0) {
            device_list[0].rowNum = rowNum;
            for (const [key, value] of Object.entries(script_count)) {
              const index = device_list.findIndex(
                (item) => item?.script_id === Number(key)
              );
              device_list[index].scriptRowNum = value;
            }
          }
          task_configuration = task_configuration.concat(device_list);
        }
        task.task_configuration = task_configuration;
      }
    }
    return task_list.filter(
      (data) =>
        !search || data.task_name?.toLowerCase().includes(search.toLowerCase())
    );
    // .sort(compare("start_timestamp"));
  }

  get getDeviceSpecs() {
    // status -> 0: 离线, 1: 占用 , 2: 空闲
    const device_list: any[] = readDeviceSpecs(store);

    for (let device of device_list) {
      Object.assign(device, device.model);
      if (device.is_online == false && device.is_running == false) {
        device.status1 = "离线";
      } else if (device.is_online == true && device.is_running == false) {
        device.status1 = "空闲/在线";
      } else {
        device.status1 = "占用";
      }
      if (!device.is_online) {
        device.status = "离线";
      } else if (device.is_running) {
        device.status = "占用";
      } else {
        device.status = "空闲";
      }
    }

    return device_list;
  }
  triggerTypeChange(ruleForm: any) {
    ruleForm.global_settings_trigger_value_day = "1";
    ruleForm.global_settings_trigger_value_time = "00:01";
  }
  triggerChange(ruleForm: any) {
    if (ruleForm.global_settings_trigger_type == 1) {
      ruleForm.global_settings_downloader_type = 1;
      ruleForm.global_settings_trigger_value = "";
      ruleForm.global_settings_trigger_ios_value = "";
      ruleForm.global_settings_downloader_pipeline = "";
      ruleForm.global_settings_downloader_pipeline2 = "";
      ruleForm.global_settings_downloader_time = [];
      ruleForm.global_settings_downloader_build_id = '';
      ruleForm.global_settings_downloader_build_id2 = ''
    }

    ruleForm.global_settings_trigger_value_interval = "week";
    ruleForm.global_settings_trigger_value_day = "1";
    ruleForm.global_settings_trigger_value_time = "00:01";
  }
  downloderTypeChange(ruleForm: any) {
    ruleForm.global_settings_downloader_pipeline = "";
    ruleForm.global_settings_downloader_build_id = "";
    ruleForm.global_settings_downloader_pipeline2 = "";
    ruleForm.global_settings_downloader_build_id2 = "";
  }

  public getScripts(scene_id?: number | null) {
    const scriptList = readSimpleScriptList(store);
    if (scene_id) {
      return scriptList.filter((script) => script.scene === scene_id);
    } else {
      return scriptList;
    }
  }
  public createTime(timeStr) {
    if (timeStr) {
      const [hourStr, minuteStr] = timeStr.split(":");
      const date = new Date();
      date.setHours(Number(hourStr));
      date.setMinutes(Number(minuteStr));
      return date;
    } else {
      return "";
    }
  }
  getPiplinePkgs(piplink_key: string) {
    const pkg = readPipelinePkgList(store).filter(
      (data) => data.pipeline.pipeline_id === piplink_key
    );
    return unique_json(pkg, "build_num");
  }

  // 获取流水线列表
  public get getPipelines() {
    return readPipelineList(store);
  }

  // 获取账号列表
  public get getAccounts() {
    return readAccountList(store);
  }

  // 获取项目场景列表
  public get getProjectScenes() {
    return readProjectScenes(store);
  }

  public get getTaskStats() {
    const task_stats: any[] = readTaskStats(store);
    for (let stat of task_stats) {
      stat.start_timestamp =
        new Date(stat.task_record?.start_date).getTime() || "-";
    }
    return task_stats;
  }

  // 合并单元行
  public taskGroupSpanMethod({ row, column, rowIndex, columnIndex }: any) {
    if (columnIndex === 0) {
      return {
        rowspan: row.rowNum, // 合并行数
        colspan: row.rowNum > 0 ? 1 : 0, // 合并列数
      };
    }
    if (columnIndex === 1) {
      return {
        rowspan: row.scriptRowNum, // 合并行数
        colspan: row.scriptRowNum > 0 ? 1 : 0, // 合并列数
      };
    }
  }
  // 报告类型
  public get report_type() {
    let list = [];
    let falseArray: any = [36, 34, 40, 47, 12, 32, 57, 4, 18, 59];
    if (
      this.localProject === 40 ||
      this.localProject === 32 ||
      this.localProject === 47
    ) {
      list = [
        { name: "Default", value: 0 },
        { name: "局内皮肤测试  ", value: 4 },
        { name: "局外皮肤测试", value: 3 },
        { name: "5V5真人测试", value: 9 },
        { name: "极限测试", value: 8 },
        { name: "皮肤异常测试", value: 13 },
      ];
    } else if (this.localProject == 57) {
      list = [
        { name: "Default", value: 0 },
        { name: "局内皮肤测试  ", value: 4 },
        { name: "局外皮肤测试", value: 3 },
        { name: "5V5真人测试", value: 9 },
        { name: "极限测试", value: 8 },
        { name: "皮肤异常测试", value: 13 },
        { name: "灵宝广场离线测试", value: 48 },
        { name: "首次局外皮肤测试", value: 50 },
        { name: "次元农场", value: 55 },
        { name: "闪卡&半身像", value: 58 },
        { name: "次元广场灵宝", value: 59 },
        { name: "次元动作", value: 60 },
        { name: "闪卡Loading", value: 61 },
      ];
    } else if (this.localProject == 34) {
      list = [
        { name: "Default", value: 0 },
        { name: "局内皮肤测试  ", value: 4 },
        { name: "局外皮肤测试", value: 3 },
        { name: "5V5真人测试", value: 9 },
        { name: "极限测试", value: 8 },
        { name: "皮肤异常测试", value: 13 },
        { name: "内存测试-10真人", value: 34 },
        { name: "内存测试-1真人", value: 35 },
        { name: "1 真人 9 AI", value: 37 },
      ];
    }
    // if (this.localProject === 32) {
    //   list = [
    //     { name: "Default", value: 0 },
    //     { name: "皮肤异常测试", value: 13 },
    //   ];
    // }
    else if (this.localProject === 36) {
      list = [
        { name: "Default", value: 0 },
        { name: "皮肤测试报告", value: 5 },
        { name: "UI性能测试报告", value: 25 },
      ];
    } else if (this.localProject === 18) {
      list = [
        { name: "Default", value: 0 },
        { name: "5V5真人测试", value: 9 },
      ];
    } else if (this.localProject === 4) {
      list = [
        { name: "Default", value: 0 },
        { name: "分支性能", value: 21 },
        { name: "主干性能", value: 22 },
        { name: "分支dev", value: 23 },
        { name: "主干dev", value: 24 },
        { name: "登录测试", value: 30 },
        { name: "iOS登录", value: 41 },
      ];
    } else if (this.localProject === 59 || this.localProject === 71) {
      list = [
        { name: "Default", value: 0 },
        { name: "关卡测试 ", value: 42 },
        { name: "UI测试 ", value: 43 },
        { name: "UI测试&关卡测试 ", value: 44 },
      ];
    } else if ([12, 61, 70].includes(this.localProject)) {
      list = [{ name: "Default", value: 0 }, { name: "稳定性测试", value: 51 }];
    } else if (this.localProject === 58) {
      list = [{ name: "Default", value: 0 }, { name: "主干性能", value: 22 }, { name: "分支性能", value: 21 }, { name: "武器局内", value: 52 }, { name: "武器局内外", value: 53 },];
    } else if (this.localProject === 14) {
      list = [{ name: "Default", value: 0 }, { name: "局内皮肤测试  ", value: 4 }, { name: "局外皮肤测试", value: 3 }];
    } else if (falseArray.every((v) => v != this.localProject)) {
      list = [{ name: "Default", value: 0 }];
    }

    return list;
  }
  public get upload_svn() {
    let list = [
      { name: "不上传SVN", value: false },
      { name: "上传SVN", value: true },
    ];

    return list;
  }
  public sceneChange(task: any) {
    const scriptList = readSimpleScriptList(store).filter(
      (script) => script.scene === task.scene_id
    );
    (task.device_group as any[]).forEach((device) => {
      const filter_result = scriptList.filter(
        (item) => item.script_id === device.script
      );
      if (filter_result.length === 0) {
        device.script = scriptList[0]?.script_id || "";
      }
    });
  }
  // 选择英雄重置皮肤
  public heroChange(device: any) {
    const skin_list = this.get_skin(device.hero_id);
    device.skin_id = skin_list[0].skin_id || "";
  }

  public check_device(device: any, device_group: any[]) {
    const device_length = device_group?.filter((item) => item.id === device.id)
      .length;
    return device_length > 1 ? true : false;
  }

  public sumbitSettings() {
    // todo: 兼容邮件收件人格式，例如 "user1;user2" 兼容 "user1@tencent.com;user2@tencent.com"
    // 将receiver_str转化为receiver
    this.report_settings.notify.email.receiver = (this.report_settings.notify
      .email.receiver_str as string).split(";");
  }

  // public AutoDetect(ruleForm:any) {
  //   ruleForm.global_settings_downloader_type = 1;
  //   ruleForm.global_settings_downloader_build_id = ruleForm.global_settings_trigger_value;
  // }

  // 基础设置
  // 判断项目名称
  public get judgeName() {
    // let judge = readProjectDetail(store).project_name === 'Top机型测试' ? true : false
    return false;
  }
  // 手机品牌选择
  public radio = "全部";
  public radioGroup = [
    "全部",
    "Tencent",
    "SAMSUNG",
    "HUAWEI",
    "XIAOMI",
    "vivo",
    "oppo",
    "REALME",
    "ONEPLUS",
    "GooGLE",
  ];
  // 分页默认
  public activeName = "all_project";
  // 序号
  public indexMethod(index: any) {
    // return index + 1 + (this.current_page - 1) * this.record;
    return index + 1;
  }
  public labelGroup = [
    {
      label: "设备品牌",
      prop: "prop1",
    },
    {
      label: "设备型号",
      prop: "prop2",
    },
    {
      label: "设备名称",
      prop: "prop3",
    },
    {
      label: "档位",
      prop: "prop4",
    },
    {
      label: "CPU",
      prop: "prop5",
    },
    {
      label: "CPU核数",
      prop: "prop6",
    },
    {
      label: "GPU",
      prop: "prop7",
    },
    {
      label: "设备状态",
      prop: "prop8",
    },
    {
      label: "系统版本",
      prop: "prop9",
    },
    {
      label: "序列号",
      prop: "prop10",
    },
  ];

  public all_table_data = [
    {
      prop1: "华为",
      prop2: "P30 pro",
      prop4: "一档位",
      status: 1,
    },
  ];
}
